import React from 'react'

import type { TChatSource } from '@homepal/api-contract'
import { Action, Context } from 'types/GlobalUserEvents'
import { TMetricView } from 'types/GlobalMetric'

import ChatBox from 'components_new/organisms/ChatBox'

export interface RightSidebarProps {
  // only the first rows were fetched; more match the selection
  hasMoreRows: boolean
  historyEnabled: boolean
  metricView?: TMetricView & { title: string }
  onExpandedChange: (expanded: boolean) => void
  // The dialog's own logger, so chat events carry the same entry-point context
  // and dashboard/analysis/report ids as every other event it emits.
  onLogEvent: (action: Action, input?: string | null, context?: Context) => void
  rowCount: number | null
  source: TChatSource
  // The analysis or kpi option the chat is anchored to, when there is one.
  sourceId?: string
}

const RightSidebar = (props: RightSidebarProps) => {
  const {
    hasMoreRows,
    historyEnabled,
    metricView,
    onExpandedChange,
    onLogEvent,
    rowCount,
    source,
    sourceId
  } = props

  return (
    <>
      {metricView ? (
        <ChatBox
          hasMoreRows={hasMoreRows}
          historyEnabled={historyEnabled}
          onExpandedChange={onExpandedChange}
          onLogEvent={onLogEvent}
          metricTitle={metricView.title}
          metricView={metricView}
          rowCount={rowCount}
          source={source}
          sourceId={sourceId}
        />
      ) : null}
    </>
  )
}

export default RightSidebar
